// extracted by mini-css-extract-plugin
module.exports = {"page":"menu_page__3TV_m","menu-row":"menu_menu-row__3uCLy"};